<template>
    <div class="container">
        <template v-if="rejectionBlocks.length > 0">
            <template v-for="(block, idx) in rejectionBlocks">
                <CommonBlockText
                    :key="`preview-rejection-${idx}`"
                    v-if="[ALL_BLOCK_TYPE.BLOCK_DISPLAY_1].includes(block.block_type)"
                    :index.sync="indexCommonOption"
                    :inforBlock="block"
                    :provinceInfor="inforProvince"
                    :settingDesign="settingDesign"
                    :configBlock="configBlockForm"
                    :conditionPageShow="typePageShow"
                    :pagePreview="true"
                    @getAddress="handleGetAddress"
                    :settingRequireLabel="settingRequireLabel"
                    :settingConfirmLabel="settingConfirmLabel"
                />
            </template>
        </template>
        <div v-else v-html="inforDataRejection?.extension?.no_win_content"></div>
    </div>
</template>

<script>
import CommonBlockText from '../common-text.vue';
import { ALL_BLOCK_TYPE } from '@/config/constants';

export default {
    name: 'FormBSeriaRejection',
    components: {
        CommonBlockText
    },
    props: {
        inforDataRejection: {
            type: Object,
            default: null
        },
        settingDesign: {
            type: Object,
            default: null
        },
        listInforPrize: {
            type: Array,
            default: () => []
        },
        formInit: {
            type: Object,
            default: () => ({})
        },
        configBlockForm: {
            type: Object,
            default: () => ({})
        },
        inforProvince: {
            type: Object,
            default: () => null
        },
        typePageShow: {
            type: String,
            default: ''
        },
        settingRequireLabel: {
            type: Object,
            default: () => null
        },
        settingConfirmLabel: {
            type: Object,
            default: () => null
        },
        indexCommonOption: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE
        };
    },
    computed: {
        winningData() {
            // Rejection screen might be tied to a specific prize if it matched but was rejected
            return (this.listInforPrize || []).find((item) => item.id == this.formInit?.serial_prize);
        },
        rejectionBlocks() {
            return (this.winningData?.blocks || []).filter((b) => b.is_rejection || b.extension?.is_rejection);
        }
    },
    methods: {
        handleGetAddress(data) {
            this.$emit('getAddress', data);
        }
    },
    watch: {
        indexCommonOption(val) {
            this.$emit('update:indexCommonOption', val);
        }
    }
};
</script>
